<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title" style="padding:0px;">Hay Before the Bookshops<br/> or the Beeman’s Family</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-200"><a href="#/text/Section0001#ack">Acknowledgement</a></li>
<li id="toc-li-4"><a href="#/text/ch004#introduction">Introduction</a></li>
<li id="toc-li-5"><a href="#/text/ch005#at-the-door">1. At the Door</a><ol class="toc"><li id="toc-li-6"><a href="#/text/ch005#hay-has-everything"></a></li>
<li id="toc-li-7"><a href="#/text/ch005#the-beekeepers-family"></a></li>
</ol></li>
<li id="toc-li-8"><a href="#/text/ch006#under-the-thatched-roof">2. Under the Thatched Roof</a>
</li>
<li id="toc-li-15"><a href="#/text/ch007#the-boundless-garden">3. The Boundless Garden</a>
</li>
<li id="toc-li-25"><span href="#/text/ch008#top-o-lane" title="Link target outside of Sample">4. Top o’ Lane</span>
</li>
<li id="toc-li-38"><span href="#/text/ch009#the-family-at-3-market-street" title="Link target outside of Sample">5. The Family at 3 Market Street</span>
</li>
<li id="toc-li-47"><span href="#/text/ch010#my-mother-the-housewife" title="Link target outside of Sample">6. My Mother the Housewife</span>
</li>
<li id="toc-li-60"><span href="#/text/ch011#strict-school" title="Link target outside of Sample">7. Strict School</span>
</li>
<li id="toc-li-69"><span href="#/text/ch012#only-catholics-go-to-heaven" title="Link target outside of Sample">8. Only Catholics go to Heaven</span>
</li>
<li id="toc-li-77"><span href="#/text/ch013#being-ill-and-the-nhs" title="Link target outside of Sample">9. Being Ill and the NHS</span>
</li>
<li id="toc-li-83"><span href="#/text/ch014#my-father-the-beeman" title="Link target outside of Sample">10. My Father the Beeman</span>
</li>
<li id="toc-li-93"><span href="#/text/ch015#the-town-is-our-playground" title="Link target outside of Sample">11. The Town is Our Playground</span>
</li>
<li id="toc-li-100"><span href="#/text/ch016#mother-nature" title="Link target outside of Sample">12. Mother Nature</span><ol class="toc"><li id="toc-li-101"><span href="#/text/ch016#town-walks" title="Link target outside of Sample"></span></li>
<li id="toc-li-102"><span href="#/text/ch016#in-the-countryside" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-103"><span href="#/text/ch017#hay-before-the-bookshops" title="Link target outside of Sample">13. Hay Before the Bookshops</span>
</li>
<li id="toc-li-108"><span href="#/text/ch018#upstanding-people" title="Link target outside of Sample">14. Upstanding People</span>
</li>
<li id="toc-li-112"><span href="#/text/ch019#the-coronation-and-other-excitements" title="Link target outside of Sample">15. The Coronation and Other Excitements</span>
</li>
<li id="toc-li-119"><span href="#/text/ch020#the-strangeness-of-james" title="Link target outside of Sample">16. The Strangeness of James</span><ol class="toc"><li id="toc-li-120"><span href="#/text/ch020#platonic-friendship" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-121"><span href="#/text/ch021#nineteen-fifty-four" title="Link target outside of Sample">17. Nineteen Fifty-Four</span>
</li>
<li id="toc-li-133"><span href="#/text/ch022#bibliography" title="Link target outside of Sample">Bibliography</span></li>
<li id="toc-li-134"><span href="#/text/ch023#appendix-1-three-other-meal-plans" title="Link target outside of Sample">Appendix 1 Three Other Meal Plans</span></li>
<li id="toc-li-135"><span href="#/text/ch024#appendix-2-eileen-ashton-reading-list-january-to-october-1953" title="Link target outside of Sample">Appendix 2 Eileen Ashton Reading List, January to October 1953</span></li>
<li id="toc-li-136"><span href="#/text/ch025#endnotes" title="Link target outside of Sample">Endnotes</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?e87d4438